<template lang="pug">
  .width-100(
    :label='label'
    :isOptional='isOptional'
    :errorMessage='errorMessage'
    :fieldHeight='fieldHeight'
    :valueLength='valueLength'
    :maxCharacters='maxCharacters'
    :showError='showError'
    :disabled='disabled'
  )
    .column.width-100
      .row.space-between.middle(v-if='label')
        label.text-normal(v-html='`${ label } ${ showRequiredMark ? `${$t("inputs.requiredMark")}` : ""}`')
        span.text-small.gray(v-if='maxCharacters') {{ value.length + '/' + maxCharacters }}
      input.input-base.input-border.width-100.text-normal(
        :name='name'
        :value='value'
        :class='italicPlaceholder && "italicPlaceholder"'
        :maxLength='maxCharacters'
        :placeholder='placeholder'
        @input='updateInput'
        @blur='verifyValidation'
        @keydown.enter='submit'
        :type='inputType'
        :disabled='disabled'
      )
      .row.m-top-1(v-if='showError')
        simple-svg.error-icon.red-icon.m4-right-2.red-stroke-icon(:filepath='errorIcon' :width='"16px"' :height='"16px"')
        span.text-small.red
          | {{ errorMessage }}
</template>

<script>
import errorIcon from '@/assets/ic_stop.svg'
import inputValidation from '@/mixins/inputsValidationMixin'

export default {
  mixins: [ inputValidation ],
  props: {
    name: { type: String, required: true },
    label: { type: String },
    value: { type: [ String, Number ] },
    maxCharacters: { type: Number },
    placeholder: { type: String },
    isOptional: { type: Boolean },
    updateMethod: { type: Function },
    errorMessage: { type: String },
    fieldHeight: { type: String, default: 'auto' },
    inputType: { type: String, default: 'text' },
    disabled: { type: Boolean },
    showRequiredMark: { type: Boolean },
    italicPlaceholder: { type: Boolean }
  },
  data() {
    return {
      errorIcon
    }
  },
  computed: {
    valueLength() {
      return this.value ? this.value.length : 0
    }
  },
  methods: {
    updateInput(event) {
      this.updateMethod(event.target.value, this.name)
    },
    submit(event) {
      this.$emit('submit', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  height: 16px;
  width: 16px;
}
.input-base{
  &.italicPlaceholder{
    &::placeholder{
      font-style: italic;
    }
  }
}
</style>
